import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl;
const endpoint = '/api/estructuraActualizarInforme';

const estructuraService = {
  async obtenerEstructura() {
    try {
      const url = `${baseUrl}${endpoint}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error(`Error al obtener la estructura:`, error);
      throw error;
    }
  }
};

export default estructuraService;
